// extracted by mini-css-extract-plugin
export var bounce = "p_bx";
export var demo = "p_bs";
export var demo_callout = "p_bw";
export var demo_content = "p_bt";
export var demo_text = "p_bv";